import { render, staticRenderFns } from "./analyze-sms-task.vue?vue&type=template&id=31ba8962&scoped=true"
import script from "./analyze-sms-task.vue?vue&type=script&lang=js"
export * from "./analyze-sms-task.vue?vue&type=script&lang=js"
import style0 from "./analyze-sms-task.vue?vue&type=style&index=0&id=31ba8962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba8962",
  null
  
)

export default component.exports